<template lang="pug">
.card
	.card-header.bg-warning.text-dark
		|Comentarios (Más recientes primero)
	.bg-light.card-body.text-right(v-if="tarea.fase !== 'finalizada'")
		textarea.form-control.form-control-sm(placeholder="Escribe tu comentario" v-model="texto")
		button.btn.btn-primary.btn-sm.mt-1(@click="enviar()")
			|Enviar
	div(style="max-height:600px;overflow-y:auto;margin:0;padding:0;")
		.card-body.m-0.p-2(:class="(index % 2 === 1) ? 'bg-light' : ''" v-for="(comentario, index) in tarea.comentarios" :key="comentario.ID_comentario")
			b {{comentario.usuario.nombre}} | 
			span.text-muted {{comentario.fecha}}
			p.m-0
				|{{comentario.comentario}}
</template>

<script>
import API from '../../services/api'

export default {
	name: 'comentarios',
	props: ['tarea'],

	data: function () {
		return {
			texto: null
		}
	},

	methods: {
		enviar () {
			const datos = {
				ID_tarea: this.tarea.ID_tarea,
				comentario: this.texto
			}

			API.setComentarioTarea(datos)
				.then(res => {
					this.$emit('update:tarea', res.data.tarea)
					this.texto = null
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/comentarios.vue